<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header :headerName="'Aparelho'" :showBtn="false" :btnName="''" :btnRoute="''" :css="'container-fluid'"/>

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loading"/>

            <!-- Filters -->
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div v-if="!loading" class="col-xs-12 col-sm-12 col-md-12 default-box filters">
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="userId">Usuário ID</label>
                      <input v-model="dataSearch.userId" type="text" class="form-control" id="userId" name="userId">
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="name">Device ID</label>
                      <input v-model="dataSearch.deviceId" type="text" class="form-control" id="name" name="name">
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Banco</label>
                      <input v-model="dataSearch.header" type="text" class="form-control" name="userId"
                             placeholder="UserID" required>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <button v-on:click="searchUser()">Pesquisar</button>
                </div>
              </div>
            </div>

            <!-- No Result -->
            <div v-if="!loading && (dataUser !== '' && !dataUser.length) && !failRequest"
                 class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Sem resultado na pesquisa.</p>
              </div>
            </div>

            <!-- Fail Request -->
            <div v-if="!loading && failRequest" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Falha na requisição.</p>
              </div>
            </div>

            <!-- Table -->
            <div v-if="!loading && dataUser.length" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box">
                <div class="portlet-title">
                  <div class="caption">
                    <span
                      class="caption-subject font-blue bold uppercase">Quantidade total ({{ dataUser.length }})</span>
                  </div>
                </div>

                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <table class="table table-hover table-light table-icon">
                      <thead>
                      <tr>
                        <th> USER ID</th>
                        <th> DEVICE ID</th>
                        <th> APARELHO</th>
                        <th> VERSÃO DA LOJA</th>
                        <th> VERSÃO APARELHO</th>
                        <th> TOTAL DE ACESSO</th>
                        <th> AÇÕES</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="a in dataUser">
                        <td>{{ a.userId }}</td>
                        <td>{{ a.deviceId }}</td>
                        <td>{{ a.deviceModel }}</td>
                        <td>{{ a.version }}</td>
                        <td>{{ a.soVersion }}</td>
                        <td>{{ a.totalAccess }}</td>
                        <td>
                          <a :disabled="loadingBloq"
                             v-bind:class="{'disable': loadingBloq, 'btn-success': a.isBlocked, 'btn-danger': !a.isBlocked}"
                             v-on:click="changeBlock(a)">
                            <span v-if="!loadingBloq">
                              <span v-if="a.isBlocked">Desbloquear</span>
                              <span v-else>Bloquear</span>
                            </span>
                            <div class="loading-btn" v-else>
                              <div class="spinner-btn">
                                <div class="rect1"></div>
                                <div class="rect2"></div>
                                <div class="rect3"></div>
                                <div class="rect4"></div>
                                <div class="rect5"></div>
                              </div>
                            </div>
                          </a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../../components/default/topMenu.vue";
import pageHeader from "../../../components/default/pageHeader.vue";
import fullLoading from "../../../components/default/fullLoading.vue";
import swal from 'sweetalert';

import {
  USERS_DEVICES
} from "../../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../../requestConfig";

export default {
  name: "block-devices",
  components: {
    topMenu,
    pageHeader,
    fullLoading
  },
  data() {
    return {
      loading: false,
      loadingBloq: false,
      failRequest: false,
      dataUser: '',
      dataSearch: {
        userId: '',
        deviceId: '',
        header: 'AAAA'
      }
    }
  },
  methods: {
    searchUser() {
      this.loading = true;

      let url = USERS_DEVICES + "?userId=" + this.dataSearch.userId;

      if (this.dataSearch.deviceId)
        url += "&deviceId=" + this.dataSearch.deviceId;

      UTIL_SERVICE.console("URL SEARCH:", url);
      REQUEST_SERVICE.requestContext('GET', url, this.dataSearch.header).then((response) => {
        UTIL_SERVICE.console("RESULT SEARCH USER:", response.data);

        this.dataUser = response.data;
        this.loading = false;
        this.failRequest = false;
      }).catch((reason) => {
        this.loading = false;
        this.failRequest = true;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    },
    changeBlock(value) {
      let text = "";
      if (value.isBlocked) {
        text = "Você tem certeza que deseja ativar o aparelho:" + value.deviceModel;
      } else {
        text = "Você tem certeza que deseja desativar o aparelho:" + value.deviceModel;
      }

      swal({
        title: "Aviso",
        text: text,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
        .then((valueInput) => {
          if (valueInput) {
            this.loadingBloq = true;

            let url = DESACTIVE_ACTIVE + "?i=" + id + "&motive=" + valueInput;
            REQUEST_SERVICE.requestContext('GET', url, contextCode).then((response) => {
              UTIL_SERVICE.console("RESULT DESACTIVE_ACTIVE:", response.data);

              ALERT_SERVICE.swal("Aviso", response.data, "success");
              this.loadingBloq = false;
              this.searchUser();
            }).catch((reason) => {
              this.loadingBloq = false;

              ALERT_SERVICE.showMsgError(reason.response.data.erros);
            });
          }
        });
    }
  },
  beforeMount() {
  }
}
</script>

<style lang="scss">
.btn-danger {
  padding: 4px 20px;
  border-radius: 4px !important;
  background-color: #e30606 !important;

  &:hover {
    background: #c70303 !important;
  }
}

.btn-success {
  padding: 4px 20px;
  border-radius: 4px !important;
  background-color: #00a651 !important;

  &:hover {
    background: #00a651 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/user/blockDevice/blockDevice.vue